import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";

const mapStateToProps = (state) => {
  return {
    AddConnectorsModel: state.manufacturer.AddConnectorsModel,
    AddConnectorsTable: state.manufacturer.AddConnectorsTable,
    SelectVehicleListdata: state.manufacturer.SelectVehicleListdata,
    SelectVehicleModelListdata: state.manufacturer.SelectVehicleModelListdata,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postAddConnectorsAction: ManufacturerTableAction.postAddConnectorsModel,
      getAddConnectorsAction: ManufacturerTableAction.getAddConnector,
      ConnectorsEnableDisableAction:
        ManufacturerTableAction.ConnectorsEnableDisable,
      UdateConnectorAction: ManufacturerTableAction.UdateConnectorAction,
    },
    dispatch
  );

const ConnectorsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ConnectorsStore;
